module.exports = __webpack_public_path__ + "img/parameter.16bc7b6b.png";